'use client'

import { useEffect, useRef } from 'react'
import { usePathname } from 'next/navigation'
import { breadcrumbTracker } from '@/lib/monitoring/breadcrumbs'

/**
 * Lightweight navigation tracker component
 * Only tracks route changes, doesn't cause re-renders
 */
export function NavigationTracker() {
  const pathname = usePathname()
  const previousPathnameRef = useRef<string | null>(null)

  useEffect(() => {
    // Skip initial mount
    if (previousPathnameRef.current === null) {
      previousPathnameRef.current = pathname
      return
    }

    // Only track if pathname actually changed
    if (previousPathnameRef.current !== pathname) {
      breadcrumbTracker.add({
        category: 'navigation',
        message: `Navigated to ${pathname}`,
        data: {
          from: previousPathnameRef.current,
          to: pathname
        }
      })

      previousPathnameRef.current = pathname
    }
  }, [pathname])

  return null // This component doesn't render anything
}

